module.exports = __webpack_public_path__ + "img/im_scrollfeature_15@2x.4b1a0070.jpg";